import type { IframePoolOrderItem } from '../../../modules/api';
import { formatPrice } from '../../../modules/currency';

export interface MyPacksStatsRowProps {
  inventory: IframePoolOrderItem[];
  /** Backend sum over the whole vault. Null (older backend) → sum of the
   *  loaded cards, which is the same until the grid paginates. */
  total: number | null;
}

const PRICE_DECIMALS = 2;

/**
 * Sleek Cards-tab total (partner feedback 2026-10-01): one "Total Vault
 * Value" row — cards sell at full value, so the estimated and sellable
 * totals are the same number. Label left, value right; on ≥600px label over
 * a larger value. Colours keep the existing estimated-value knobs.
 */
export function MyPacksStatsRow({ inventory, total }: MyPacksStatsRowProps) {
  const vaultValue = total ?? inventory.reduce((acc, item) => acc + (item.fairMarketValue ?? 0), 0);
  return (
    <dl
      className="flex w-full flex-col text-[14px] leading-[20px] font-medium tracking-[-0.15px] @[600px]:w-auto"
      style={{ fontFamily: 'var(--co-MyPacksStatsBar-fontFamily, Inter), system-ui, sans-serif' }}
    >
      <div
        data-co-component="MyPacksStatEstimatedValue"
        className="flex items-center justify-between gap-3 @[600px]:flex-col @[600px]:items-start @[600px]:gap-1"
      >
        <dt
          className="@[600px]:text-[13px] @[600px]:leading-[18px]"
          style={{ color: 'var(--co-MyPacksStatEstimatedValue-labelColor, #6D707C)' }}
        >
          Total Vault Value:
        </dt>
        <dd
          className="text-[14px] @[600px]:text-[22px] @[600px]:leading-[28px] @[600px]:font-bold"
          style={{ color: 'var(--co-MyPacksStatEstimatedValue-valueColor, #FFFFFF)' }}
        >
          {formatPrice(vaultValue, PRICE_DECIMALS)}
        </dd>
      </div>
    </dl>
  );
}
